// extracted by mini-css-extract-plugin
export var dateby = "billtopper-module--dateby--ZAH9i";
export var deadBill = "billtopper-module--dead-bill--AuStt";
export var deadBillIcon = "billtopper-module--dead-bill-icon--+DdsY";
export var dek = "billtopper-module--dek--gli--";
export var header = "billtopper-module--header--YXiYE";
export var hed = "billtopper-module--hed--KI2sh";
export var kicker = "billtopper-module--kicker--Gu3L-";
export var mergedBill = "billtopper-module--merged-bill--hjf7L";
export var mergedBillIcon = "billtopper-module--merged-bill-icon--GFaMr";
export var textContainer = "billtopper-module--textContainer--yMQtp";